import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgInfo = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 36,
	height: 36,
	viewBox: "0 0 36 36",
	fill: "#357DED",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M17.8287 3.65967C9.88006 3.65967 3.42896 10.1108 3.42896 18.0595C3.42896 26.0081 9.88006 32.4592 17.8287 32.4592C25.7774 32.4592 32.2285 26.0081 32.2285 18.0595C32.2285 10.1108 25.7774 3.65967 17.8287 3.65967ZM19.2687 25.2593H16.3888V16.6195H19.2687V25.2593ZM19.2687 13.7395H16.3888V10.8596H19.2687V13.7395Z" })
});
export default SvgInfo;
